import { STATIC_ASSETS } from 'webclient.constants';
import {
  LANGUAGE_CODE_AR_SA,
  LANGUAGE_CODE_BN_IN,
  LANGUAGE_CODE_GU_IN,
  LANGUAGE_CODE_HE_IL,
  LANGUAGE_CODE_HY_AM,
  LANGUAGE_CODE_JA_JP,
  LANGUAGE_CODE_ZH_CN,
  LANGUAGE_CODE_ZH_TW,
  LANGUAGE_CODE_KO_KR,
  LANGUAGE_CODE_ML_IN,
  LANGUAGE_CODE_NE_NP,
  LANGUAGE_CODE_FA_IR,
  LANGUAGE_CODE_PA_IN,
  LANGUAGE_CODE_SR_RS,
  LANGUAGE_CODE_TA_IN,
  LANGUAGE_CODE_TE_IN,
  LANGUAGE_CODE_TH_TH,
  LANGUAGE_CODE_UR_PK,
  LANGUAGE_CODE_VI_VN,
  LANGUAGE_CODE_YI_YD,
  LANGUAGE_CODE_SI_LK,
  LANGUAGE_CODE_ES_US,
  LANGUAGE_CODE_HR_HR,
  LANGUAGE_CODE_FIL_PH,
  LANGUAGE_CODE_FR_FR,
  LANGUAGE_CODE_DE_DE,
  LANGUAGE_CODE_HT_HT,
  LANGUAGE_CODE_HU_HU,
  LANGUAGE_CODE_ID_ID,
  LANGUAGE_CODE_IT_IT,
  LANGUAGE_CODE_EL_GR,
  LANGUAGE_CODE_PL_PL,
  LANGUAGE_CODE_PT_PT,
  LANGUAGE_CODE_PT_BR,
  LANGUAGE_CODE_SM_WS,
  LANGUAGE_CODE_RU_RU,
  LANGUAGE_CODE_AM_AM,
  LANGUAGE_CODE_MN_MN,
  LANGUAGE_CODE_TI_ET,
  LANGUAGE_CODE_MY,
  LANGUAGE_CODE_KM,
} from 'global/constants';

const CDN_PATH = `${STATIC_ASSETS}/fonts/rive`;
const CDN_PATH_V2 = `${STATIC_ASSETS}/fonts/v2/rive`;

const FONTS = {
  calibre: `${CDN_PATH_V2}/CalibreSchool-Regular.ttf`,
  notoUrdu: `${CDN_PATH}/NotoNastaliqUrdu-Regular.ttf`,
  notoSc: `${CDN_PATH}/NotoSans-Regular.ttf`,
  notoScArabic: `${CDN_PATH}/NotoSansArabic-Regular.ttf`,
  notoScArmenian: `${CDN_PATH}/NotoSansArmenian-Regular.ttf`,
  notoScBengali: `${CDN_PATH}/NotoSansBengali-Regular.ttf`,
  notoScGujurati: `${CDN_PATH}/NotoSansGujarati-Regular.ttf`,
  notoScPunjabi: `${CDN_PATH}/NotoSansGurmukhi-Regular.ttf`,
  notoScHebrew: `${CDN_PATH}/NotoSansHebrew-Regular.ttf`,
  notoScJapansese: `${CDN_PATH}/NotoSansJP-Regular.ttf`,
  notoScKorean: `${CDN_PATH}/NotoSansKR-Regular.ttf`,
  notoScMalayalam: `${CDN_PATH}/NotoSansMalayalam-Regular.ttf`,
  notoScPersian: `${CDN_PATH}/NotoSansOldPersian-Regular.ttf`,
  notoScChinese: `${CDN_PATH}/NotoSansSC-Regular.ttf`,
  notoTcChinese: `${CDN_PATH}/NotoSansTC-Regular.ttf`,
  notoScTamil: `${CDN_PATH}/NotoSansTamil-Regular.ttf`,
  notoScTelugu: `${CDN_PATH}/NotoSansTelugu-Regular.ttf`,
  notoScThai: `${CDN_PATH}/NotoSansThai-Regular.ttf`,
  notoScSinhala: `${CDN_PATH}/NotoSansSinhala-Regular.ttf`,
  notoScEthiopic: `${CDN_PATH}/NotoSansEthiopic-Regular.ttf`,
  notoScMongolian: `${CDN_PATH}/NotoSansMongolian-Regular.ttf`,
  notoScMyanmar: `${CDN_PATH}/NotoSansMyanmar-Regular.ttf`,
  notoScKhmer: `${CDN_PATH}/NotoSansKhmer-Regular.ttf`,
};

export const FONTS_BY_LANGUAGE: { [key: string]: string } = {
  [LANGUAGE_CODE_BN_IN]: FONTS.notoScBengali,
  [LANGUAGE_CODE_HY_AM]: FONTS.notoScArmenian,
  [LANGUAGE_CODE_AR_SA]: FONTS.notoScArabic,
  [LANGUAGE_CODE_ZH_CN]: FONTS.notoScChinese,
  [LANGUAGE_CODE_ZH_TW]: FONTS.notoTcChinese,
  [LANGUAGE_CODE_GU_IN]: FONTS.notoScGujurati,
  [LANGUAGE_CODE_HE_IL]: FONTS.notoScHebrew,
  [LANGUAGE_CODE_JA_JP]: FONTS.notoScJapansese,
  [LANGUAGE_CODE_KO_KR]: FONTS.notoScKorean,
  [LANGUAGE_CODE_ML_IN]: FONTS.notoScMalayalam,
  [LANGUAGE_CODE_NE_NP]: FONTS.notoSc,
  [LANGUAGE_CODE_FA_IR]: FONTS.notoScPersian,
  [LANGUAGE_CODE_PA_IN]: FONTS.notoScPunjabi,
  [LANGUAGE_CODE_SR_RS]: FONTS.notoSc,
  [LANGUAGE_CODE_TA_IN]: FONTS.notoScTamil,
  [LANGUAGE_CODE_TE_IN]: FONTS.notoScTelugu,
  [LANGUAGE_CODE_TH_TH]: FONTS.notoScThai,
  [LANGUAGE_CODE_UR_PK]: FONTS.notoUrdu,
  [LANGUAGE_CODE_VI_VN]: FONTS.notoSc,
  [LANGUAGE_CODE_YI_YD]: FONTS.notoScHebrew,
  [LANGUAGE_CODE_SI_LK]: FONTS.notoScSinhala,
  [LANGUAGE_CODE_EL_GR]: FONTS.notoSc,
  [LANGUAGE_CODE_RU_RU]: FONTS.notoSc,
  [LANGUAGE_CODE_AM_AM]: FONTS.notoScEthiopic,
  [LANGUAGE_CODE_MN_MN]: FONTS.notoScMongolian,
  [LANGUAGE_CODE_TI_ET]: FONTS.notoScEthiopic,
  [LANGUAGE_CODE_MY]: FONTS.notoScMyanmar,
  [LANGUAGE_CODE_KM]: FONTS.notoScKhmer,
  // latin based character sets
  [LANGUAGE_CODE_ES_US]: FONTS.calibre,
  [LANGUAGE_CODE_HR_HR]: FONTS.calibre,
  [LANGUAGE_CODE_FIL_PH]: FONTS.calibre,
  [LANGUAGE_CODE_FR_FR]: FONTS.calibre,
  [LANGUAGE_CODE_DE_DE]: FONTS.calibre,
  [LANGUAGE_CODE_HT_HT]: FONTS.calibre,
  [LANGUAGE_CODE_HU_HU]: FONTS.calibre,
  [LANGUAGE_CODE_ID_ID]: FONTS.calibre,
  [LANGUAGE_CODE_IT_IT]: FONTS.calibre,
  [LANGUAGE_CODE_PL_PL]: FONTS.calibre,
  [LANGUAGE_CODE_PT_PT]: FONTS.calibre,
  [LANGUAGE_CODE_PT_BR]: FONTS.calibre,
  [LANGUAGE_CODE_SM_WS]: FONTS.calibre,
};
